export const CTG_QUERY_KEYS = {
  ctgListFilter: "ctgListFilter",
};
